export default __webpack_public_path__ + "static/media/pompavana-logo.d549262a.svg";